import React from 'react'
import { Button, Grid } from '@material-ui/core'
import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import { Link } from '@material-ui/core'
import { Field, Formik } from 'formik'
import { TextField } from 'formik-material-ui'

import { stepOneSchema } from '../../schemas'
import { PhoneField, PasswordField } from 'civic-champs-shared/formik/components'

function Login(props) {
  const { group, organization, user, onSubmit, onForgotPassword, goToStep, classes } = props
  const { email, phoneNumber } = user
  const isAboveSmall = isWidthUp('sm', props.width)

  return (
    <>
      <div className={classes.headerContainer}>
        <h1>{organization.name} Application</h1>
        <p>Please sign into your Civic Champs account to continue your application.</p>
      </div>
      <Formik
        initialValues={{
          email,
          phoneNumber,
          password: null,
        }}
        validationSchema={stepOneSchema}
        onSubmit={values => onSubmit(stepOneSchema.cast(values))}
        validateOnBlur={true}
        validateOnChange={false}
      >
        {({ handleSubmit, isSubmitting, values }) => (
          <form>
            <Grid className={classes.container} container spacing={2} direction="column" justify="center"
                  alignItems="center">
              <div>
                {phoneNumber ? (
                  <Field
                    fullWidth={!isAboveSmall}
                    component={PhoneField}
                    label="Phone Number"
                    name="phoneNumber"
                    variant="outlined"
                    className={classes.input}
                  />
                ) : (
                  <Field
                    fullWidth={!isAboveSmall}
                    component={TextField}
                    label="Email"
                    name="email"
                    variant="outlined"
                    className={classes.input}
                  />
                )}
              </div>
              <div>
                <Field className={classes.input} component={PasswordField} name="password" label="Password"
                       variant="outlined" />
              </div>
              <div className={classes.resendContainer}>
                <p>Forgot your password?&nbsp;
                  <a
                    onClick={async () => {
                      const nextStep = await onForgotPassword({ email: values.email, phoneNumber: values.phoneNumber })
                      goToStep(nextStep)
                    }}
                  >Reset your password</a>
                </p>
              </div>

              <div>
                <Button
                  type="submit"
                  className={classes.button}
                  disabled={isSubmitting || (!values.email && !values.phoneNumber) || !values.password}
                  onClick={handleSubmit}
                >
                  Login
                </Button>
              </div>
            </Grid>
          </form>
        )}
      </Formik>
    </>
  )
}

export default withWidth()(Login)
